import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText as PrimeInputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import useToast from "../../../../components/common/useToast";
import apiFunctions from "../../../../services/api-service";
import { AxiosError } from "axios";
import { errorHandler } from "../../../../utils/HelperFunctions";
import "../../../../assets/css/datatable.css";
import DeleteConfirmation from "../../../../components/modal-popup/delete-popup";
import BusinessMemTag from "../../../../models/businessMemTag";
import { ArrowLeftIcon, PlusIcon, ListBulletIcon } from "@heroicons/react/24/outline";

const BusinessMemTagPage: React.FC = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const navigate = useNavigate();
    const [countryData, setCountryData] = useState<BusinessMemTag[]>([]);
    const [load, setLoad] = useState(true);
    const initialized = useRef(false);
    const [itemsPerPage] = useState<any>(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [skipData, setSkipData] = useState(0);
    const { showToast }: any = useToast();
    const [companyToDelete, setCompanyToDelete] = useState<BusinessMemTag | null>(null)
    const [name, setName] = useState<string>("");
    const [sortField, setSortField] = useState<string>("createddate");
    const [sortOrder, setSortOrder] = useState<any>(-1);
    const [deleteConfirmationVisible, setDeleteConfirmationVisible] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const actionBodyTemplate = (rowData: BusinessMemTag) => {
        return (
            <div className="action-icons">
                <Button label="Edit" outlined size="small" style={{ color: "#264164", borderColor: "#264164" }} onClick={() => handleEdit(rowData)} />
                <Button label="Delete" outlined size="small" style={{ color: "#264164", borderColor: "#264164" }} onClick={() => handleDelete(rowData)} />
            </div>
        );
    };

    async function getCountryData() {
        setCountryData([{
            id: "1",
            name: "India",
        }]);
        // try {
        //     let url;
        //     setDataLoad(true);
        //     if (name !== undefined && name !== null && name !== "") {
        //         url = `/country/${skipData}/${itemsPerPage}/${sortField}/${sortOrderapi}/${name}`;
        //     } else {
        //         url = `/country/${skipData}/${itemsPerPage}/${sortField}/${sortOrderapi}`;
        //     }
        //     await apiFunctions
        //         .get(url)
        //         .then((response) => {
        //             if (response && response.data && response.data.success) {
        //                 settotalRecords(response.data.totalRecords);
        //                 let totalpage: any = Math.ceil(
        //                     parseInt(response.data.totalRecords) / parseInt(itemsPerPage)
        //                 );
        //                 settotalPages(totalpage);
        //                 setCountryData(CountryFactory.createFromJsonArray(response.data.data));
        //             } else {
        //                 showToast({
        //                     severity: "error",
        //                     summary: "Error",
        //                     detail: response.data.message,
        //                     life: 3000,
        //                 });
        //             }
        //         })
        //         .catch((err: AxiosError) => {
        //             errorHandler(err);
        //         })
        //         .finally(() => {
        //             setDataLoad(false);
        //             setLoad(false);
        //         });
        // } catch (error) {
        //     console.log(error);
        // }
    }

    const confirmDelete = async () => {
        if (companyToDelete) {
            try {
                await apiFunctions
                    .delete(`/company/delete/${companyToDelete.id}`)
                    .then((response) => {
                        if (response && response.data && response.data.success) {
                        } else {
                            showToast({
                                severity: "error",
                                summary: "Error",
                                detail: response.data.message,
                                life: 3000,
                            });
                        }
                    })
                    .catch((err: AxiosError) => {
                        errorHandler(err);
                    })
                    .finally(() => {
                        setDeleteConfirmationVisible(false);
                        setCompanyToDelete(null);
                        setSortField("createddate");
                        setSortOrder(-1);
                        setCurrentPage(0);
                        getCountryData();
                    });
            } catch (error) {
                console.log(error);
            }
        }
    };

    const handleEdit = (rowData: BusinessMemTag) => {
    };

    const handleDelete = (rowData: BusinessMemTag) => {
        setCompanyToDelete(rowData);
        setDeleteConfirmationVisible(true);
    };

    const hideDeleteConfirmation = () => {
        setDeleteConfirmationVisible(false);
        setCompanyToDelete(null);
    };

    const onSort = (e: any) => {
        setSortOrder(e.sortOrder);
        setSortField(e.sortField);
    };

    const getsearchdata = (e: any) => {
        if (e.target.value.length >= 2) {
            setName(e.target.value);
        } else {
            setName("");
            setLoad(false);
        }
    };

    useEffect(() => {
        setSkipData(currentPage * itemsPerPage);
    }, [currentPage, itemsPerPage]);

    useEffect(() => {
        if (!load) {
            getCountryData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skipData, itemsPerPage, name, sortField, sortOrder]);

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            getCountryData();
        }
    }, []);

    const handleBack = () => {
        navigate('/admin/settings');
    }

    const handleAdd = () => {
        navigate('/admin/businessmemtag/create');
    }

    const header = (
        <>
            <div className="grid grid-cols-12 gap-4 flex items-center justify-between table-header">
                <div className="col-span-6">
                    <h2 className="card-title m-0">Business Member Tag</h2>
                </div>
                <div className="col-span-6 flex gap-2 justify-end">
                    <div className="search-box">
                        <span>Search:</span>
                        <PrimeInputText
                            type="text"
                            className="search-input"
                            onChange={(e) => getsearchdata(e)}
                        />
                    </div>
                    <div className="round-btn-div">
                        <Button
                            icon={<PlusIcon className="w-6 h-6" />}
                            className="round-button"
                            onClick={handleAdd}
                        />
                    </div>
                </div>
            </div>
        </>
    );

    return (
        <>
            <div className="back-button" onClick={handleBack}>
                <ArrowLeftIcon className="w-6 h-6 text-black-700" /><h3 className="m-0">Back</h3>
            </div>
            <div className="table-margin">
                {isMobile ? (
                    <div className="bg-white w-full overflow-x-hidden box-border" style={{ borderRadius: "8px" }}>
                        <div className="p-3 pb-2">{header}</div>
                        <div className="flex flex-col gap-2 px-3 pb-3">
                            {countryData.length === 0 ? (
                                <div style={{ textAlign: "center", padding: "64px 0" }}>
                                    <ListBulletIcon style={{ width: "48px", height: "48px", margin: "0 auto 12px", display: "block", color: "#d1d5db" }} />
                                    <p style={{ margin: 0, fontSize: "14px", fontWeight: 500, color: "#6b7280" }}>No business member tags found</p>
                                </div>
                            ) : (
                                countryData.map((rowData) => (
                                    <div key={rowData.id} className="border rounded-lg p-3 w-full box-border" style={{ borderColor: "#e5e7eb" }}>
                                        <p className="m-0 font-semibold text-sm break-words" style={{ color: "#264164" }}>{rowData.name}</p>
                                        <div className="flex justify-end gap-2 mt-2">
                                            {actionBodyTemplate(rowData)}
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                ) : (
                    <DataTable
                        scrollable
                        header={header}
                        value={countryData}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        onSort={onSort}
                        resizableColumns
                        removableSort
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        paginatorTemplate="RowsPerPageDropdown PrevPageLink CurrentPageReport NextPageLink"
                        currentPageReportTemplate="{first} - {last} of {totalRecords} rows"
                        emptyMessage={
                            <div style={{ textAlign: "center", padding: "64px 0" }}>
                                <ListBulletIcon style={{ width: "48px", height: "48px", margin: "0 auto 12px", display: "block", color: "#d1d5db" }} />
                                <p style={{ margin: 0, fontSize: "14px", fontWeight: 500, color: "#6b7280" }}>No business member tags found</p>
                            </div>
                        }
                    >
                        <Column field="name" header="Name" sortable />
                        <Column header="Action" className="action-column" frozen body={actionBodyTemplate} />
                    </DataTable>
                )}
            </div>
            <DeleteConfirmation
                visible={deleteConfirmationVisible}
                onHide={hideDeleteConfirmation}
                onDelete={confirmDelete}
                header="Confirm Delete"
                message="Are you sure you want to delete this Data?"
            />
        </>
    );
};

export default BusinessMemTagPage;
